import { render, staticRenderFns } from "./GiftListPage.vue?vue&type=template&id=4dfbf3ba&scoped=true"
import script from "./GiftListPage.vue?vue&type=script&lang=js"
export * from "./GiftListPage.vue?vue&type=script&lang=js"
import style0 from "./GiftListPage.vue?vue&type=style&index=0&id=4dfbf3ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfbf3ba",
  null
  
)

export default component.exports